import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface ServicePricing {
  id: string;
  operation_type: string;
  operation_name: string;
  credits_cost: number;
  description: string | null;
  is_active: boolean;
  is_free: boolean;
}

export const usePricingConfig = () => {
  const { data: pricing, isLoading, refetch } = useQuery({
    queryKey: ['service-pricing'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('service_pricing')
        .select('*')
        .eq('is_active', true as any);
      
      if (error) throw error;
      
      // Convert to lookup map for easy access
      const pricingMap = (data || []).reduce((acc, item: any) => {
        acc[item.operation_type] = item.credits_cost;
        return acc;
      }, {} as Record<string, number>);

      return {
        map: pricingMap,
        all: data || []
      };
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  return {
    pricingMap: pricing?.map || {},
    allPricing: pricing?.all || [],
    isLoading,
    getCost: (operationType: string) => pricing?.map[operationType] || 0,
    refetch
  };
};
